// Modules
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogRef, MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { SpinnerModule } from './spinner/spinner.module';
import { ErrorDialogModule } from './error-dialog/error-dialog.module';
import { AkcNgxSharedComponentsModule } from 'akc-ngx-shared-components';
import { DatePipe, CurrencyPipe } from '@angular/common';

// Rollbar
import { RollbarService, RollbarErrorHandler, rollbarFactory } from './core/rollbar';

// Services
import { AuthService } from './secure/auth.service';
import { SecureGuard } from './secure/secure.guard';
import { CookieService } from 'ngx-cookie-service';
import { IsTestEnvGuard } from './secure/test-env.guard';
import { ClientUtilityService } from './core/services/client-utility.service';

// Interceptors
import { SpinnerInterceptorService, ErrorInterceptor } from './core/interceptors';

// Components
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';

export function clientUtilityProviderFactory(provider: ClientUtilityService) {
    return () => provider.getClientInformation();
}

export function authServiceProviderFactory ( provider: AuthService ) {
    return () => provider.initialize();
}
@NgModule({
    declarations: [
        AppComponent,
        MainComponent
    ],
    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        SpinnerModule,
        ErrorDialogModule,
        AkcNgxSharedComponentsModule
    ],
    providers: [
        SecureGuard,
        IsTestEnvGuard,
        CookieService,
        { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: ErrorHandler, useClass: RollbarErrorHandler },
        { provide: RollbarService, useFactory: rollbarFactory },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true, autoFocus: false, disableClose: true } },
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] },
        ClientUtilityService,
        { provide: APP_INITIALIZER, useFactory: clientUtilityProviderFactory, deps: [ClientUtilityService], multi: true },
        DatePipe,
        CurrencyPipe,
        AuthService,
        { provide: APP_INITIALIZER, useFactory: authServiceProviderFactory, deps: [AuthService], multi: true }],
    bootstrap: [AppComponent]
})
export class AppModule { }
